import { render } from "./MainAdvantages.vue?vue&type=template&id=7168d8a6&scoped=true"
import script from "./MainAdvantages.vue?vue&type=script&lang=js"
export * from "./MainAdvantages.vue?vue&type=script&lang=js"

import "./MainAdvantages.vue?vue&type=style&index=0&id=7168d8a6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7168d8a6"]])

export default __exports__